export const calculate_entry_money = (row) => {
    return (row['legal'] ? (row['legal']['vol buy ha'] - row['legal']['vol sell ha']) * row['pc'] : 0)
}